import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { IntStringRequest } from "./IntStringRequest";
import { MealSubsidyModifyRequest } from "./MealSubsidyModifyRequest";

@Injectable()
export class DataService_MealSubsidyType {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	MealSubsidyTypeSelectList() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/MealSubsidyTypeSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MealSubsidyTypeToggle(MealSubsidyTypeID, Active) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/MealSubsidyTypeToggle?MealSubsidyTypeID=" + MealSubsidyTypeID + "&Active=" + Active;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MealSubsidyTypeDelete(MealSubsidyTypeID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/MealSubsidyTypeDelete?MealSubsidyTypeID=" + MealSubsidyTypeID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MealSubsidyTypeCDUsed(parms: IntStringRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/MealSubsidyTypeCDUsed";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MealSubsidyTypeDescUsed(parms: IntStringRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/MealSubsidyTypeDescUsed";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MealSubsidyTypeInsert(parms: MealSubsidyModifyRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/MealSubsidyTypeInsert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MealSubsidyTypeUpdate(parms: MealSubsidyModifyRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/MealSubsidyTypeUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
